<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="#FBB040" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template>
      <v-row justify="end" class="pr-2">
        <v-col cols="12" sm="auto">
          <v-btn
            min-width="180"
            width="100%"
            x-large
            color="success"
            class="text-white"
            button
            dark
            @click="addElevatorForUser"
            ><v-icon right dark class="mr-2"> mdi-folder-plus </v-icon>
            Thêm thang
          </v-btn>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" lazy-validation>
        <p class="text-xl font-medium">Thêm thang máy</p>

        <v-row class="mt-0">
          <v-col cols="12" sm="3">
            <v-select
              v-model="elevatorId"
              :items="elevatorList"
              prepend-inner-icon="mdi-roller-shade"
              no-data-text="Không có dữ liệu"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
              outlined
              color="#FBB040"
              label="Thang máy*"
              multiple
              :hide-details="isMobile"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </v-container>
</template>

<script>
import BirthdayPicker from "~/components/atoms/BirthdayPicker";
import { mapState } from "vuex";
import { EMPTY } from "~/utils/constants";
import { required, email } from "~/utils/validation";

export default {
  name: "CreateUser",
  components: { BirthdayPicker },
  data() {
    return {
      rules: {
        required,
      },
      elevatorId: null,
      elevatorList: [],
      isLoadingActions: false,
      valid: true,
    };
  },
  async created() {
    await this.getListElevatorNotUsed();
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 640;
    },
  },
  methods: {
    async addElevatorForUser() {
      this.isLoadingActions = true;
      try {
        await this.$refs.form.validate();
        if (this.valid) {
          const { userId } = this.$route.params;
          await this.$services.elevatorService.addElevatorForUser(userId, {
            elevatorIds: this.elevatorId,
          });
          // this.$router.push({ name: "UserList" });
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingActions = false;
        this.$router.go(-1);
      }
    },
    async getListElevatorNotUsed() {
      try {
        const data = await this.$services.elevatorService.getListElevatorNotUsed();
        this.elevatorList = data;
      } catch (err) {
      } finally {
      }
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
